import React from 'react'

const Notfound = () => {
  return (
    <div>404</div>
  )
}

export default Notfound